import { useState } from "react";
import automationCycleImage from "@/assets/automation-cycle.gif";

const AutomationCycleAnimation = () => {
  const [isLoaded, setIsLoaded] = useState(false);

  return (
    <div className="w-full h-full flex items-center justify-center relative">
      {!isLoaded && (
        <div className="absolute inset-0 flex items-center justify-center bg-muted/50 rounded-lg animate-pulse">
          <div className="w-12 h-12 border-4 border-primary/30 border-t-primary rounded-full animate-spin" />
        </div>
      )}
      <img 
        alt="Automation Cycle - Scope 1, 2, 3" 
        className={`w-full h-full object-contain transition-opacity duration-300 ${isLoaded ? 'opacity-100' : 'opacity-0'}`}
        src={automationCycleImage}
        loading="lazy"
        decoding="async"
        onLoad={() => setIsLoaded(true)}
      />
    </div>
  );
};

export default AutomationCycleAnimation;